import { get } from 'lodash';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import ModulesHelper from '@core/services/modules.helper';

@Component({
  name: 'bpc-display-form',
  components: {},
})
export default class DisplayForm extends Vue {
  @Prop({ type: Boolean, default: false }) readonly groupByTabs: boolean;
  @Prop({ type: Boolean, default: false }) readonly verticalTabs: boolean;
  @Prop() readonly tabs: string[];
  @Prop() readonly lazyTabs: string[];
  @Prop() readonly conditionalTabs: string[];
  @Prop() readonly formModel: any;

  get tabsToShow(): string[] {
    if (!this.conditionalTabs) {
      return this.tabs;
    }

    return this.tabs.filter((tab, index) => {
      if (!get(this.conditionalTabs, tab, null)) {
        return tab;
      } else {
        const fieldPath = this.conditionalTabs[tab]['fieldPath']
          ? this.conditionalTabs[tab]['fieldPath']
          : null;
        const operator = this.conditionalTabs[tab]['operator']
          ? this.conditionalTabs[tab]['operator']
          : null;
        const value = this.conditionalTabs[tab]['value']
          ? this.conditionalTabs[tab]['value']
          : null;
        const module = this.conditionalTabs[tab]['module']
          ? this.conditionalTabs[tab]['module']
          : null;
        const permission = this.conditionalTabs[tab]['permission']
          ? this.conditionalTabs[tab]['permission']
          : null;

        const role = this.conditionalTabs[tab]['userHasRole']
          ? this.conditionalTabs[tab]['userHasRole']
          : null;

        const formModelName = this.conditionalTabs[tab]['formModel']
          ? this.conditionalTabs[tab]['formModel']
          : null;

        // Be able to use different form models for conditional tabs as we have for specific fields in the form
        let formModel = this.formModel;

        if (formModelName === 'accessControlConfig') {
          formModel = this.$store.getters['centerSettings/accessControlConfig'];
        }

        let tabHasToBeShown = true;

        if (fieldPath) {
          tabHasToBeShown =
            tabHasToBeShown && this.compare(operator, formModel?.[fieldPath], value);
        }
        if (module) {
          tabHasToBeShown = tabHasToBeShown && this.isModuleActivated(module);
        }
        if (role) {
          tabHasToBeShown = tabHasToBeShown && this.$authorizationService.hasRole(role);
        }
        if (permission) {
          tabHasToBeShown = tabHasToBeShown && this.$authorizationService.hasPermission(permission);
        }

        if (tabHasToBeShown) {
          return tab;
        }

        /* DEPRECATED */
        // if (!fieldPath && module && this.isModuleActivated(module)) {
        //   // Case without condition on a field
        //   return tab;
        // } else if (
        //   !module &&
        //   fieldPath &&
        //   this.compare(operator, this.formModel[fieldPath], value)
        // ) {
        //   // Case with only module check
        //   return tab;
        // } else if (
        //   fieldPath &&
        //   module &&
        //   this.isModuleActivated(module) &&
        //   this.compare(operator, this.formModel[fieldPath], value)
        // ) {
        //   // Case with condition on field + module
        //   return tab;
        // }
      }
    });
  }

  isModuleActivated(module: string): boolean {
    return this.$modulesService.hasModuleActivated(ModulesHelper[module]);
  }

  compare(operator, currentValue, targetValue) {
    switch (operator) {
      case '=':
        return currentValue == targetValue;
      case '!=':
        return currentValue != targetValue;
      case '>':
        return currentValue > targetValue;
      case '<':
        return currentValue < targetValue;
      case '>=':
        return currentValue >= targetValue;
      case '<=':
        return currentValue <= targetValue;
      case 'in':
        return targetValue.indexOf(currentValue) > -1;
      default:
        return false;
    }
  }
}
